import React, { useMemo } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  Update,
  GetById,
} from "adminApi/CustomersApi/Guest";
import { validateForm } from "utils/validation";
import { GuestValidation } from "validation/ValidationRules";
import Spinner from "Common/Globle/Spinner";
import EditGuestForm from "./Componates/EditGuestForm";
import fields from "../json/GuestFeilds.json";
import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";
import useFetchFormDataById from "Hooks/useFetchFormDataById";

const EditGuest = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  // const { formdata } = fields;

  // Initialize form values
  const contry_code= {"name":"contry_code"}
  const allFields = useMemo(
      () => [...fields.formdata,contry_code ],
      []
    );
  const initialValues = allFields.reduce((acc, field) => ({ ...acc, [field.name]: "" }), {});

  const { values, errors, handleChange, setValues ,setErrors} = useFormChange(initialValues, GuestValidation);

  // Fetch existing data by ID
  const { loading: loadingFetch } = useFetchFormDataById(id, allFields, GetById, setValues);

  // Form submit hook
  const { loading: loadingSubmit, handleSubmit } = useFormSubmit(
    async (formValues) => {
      
      const formData = new FormData();
      Object.entries(formValues).forEach(([key, val]) => {
        if(key === "contry_code"){
          formData.append(key,formValues.country_dial_code )
          return delete formValues.country_dial_code
        }
        formData.append(key, val ?? "")
      });
      return await Update({ id, data: formData });
    },
    (vals) => {
    const err =  validateForm(vals, GuestValidation)
    setErrors(err)
    return err
    },
    () => navigate(-1),
    "Guest Updated successfully"
  );
  return (
    <>
      {(loadingFetch || loadingSubmit) && <Spinner isSpinner={true} />}
      <EditGuestForm
        fields={allFields}
        values={values}
        errors={errors}
        handleChange={handleChange}
        handleSubmit={(e) => handleSubmit(e, values)}
        loading={loadingSubmit}
        title="Update Guest"
      />
    </>
  );
};

export default EditGuest;
